import ShipmentNoteList from "./ShipmentNotesList";

export default ShipmentNoteList;
